import { Component, OnInit, Input, ViewChild, Output, EventEmitter } from '@angular/core';
import { BaseComponent } from '../../Library/BaseComponent';
import { ComplainRegister, StaffAssignmentFilter } from '../../Models/RequestModels';
import { MasterDataService } from '../../Services/MasterDataService';
import { ActivatedRoute, Router } from '@angular/router';
import { CallStatuses, EntityCodes, JobOperationActions } from '../../Models/EnumModels';
import { PMSService } from '../../Services/PMSService';
import { GuestLookup, Staff_Search_Assigment } from '../../Models/ResponseModels';
import * as _ from 'lodash';
import { ComplainService } from '../../Services/ComplainService';
import { CallDescriptionLookup, CallCategoryLookup, LocationLookup } from '../../Models/GlobalEntities';
import { NgbModal, NgbActiveModal, NgbModalRef, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { UserService } from '../../Services/UserService';
import { JobOperations } from '../JobOperations/JobOperations';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';

@Component({
    selector: 'ManualAssign',
    templateUrl: './ManualAssign.html'
})

export class ManualAssign extends BaseComponent implements OnInit {
    @ViewChild('content') content;
    CallDescription: CallDescriptionLookup;
    PropertyId: number;
    LocationId: number;
    CallDescriptionId: number;

    CallCategory: CallCategoryLookup;
    Location: LocationLookup;
    StaffList: Array<Staff_Search_Assigment>;
    lstMasterStaffList: Array<Staff_Search_Assigment>;
    Keyword: string = "";
    Filter: number = 1;
    SortBy: number = 1;
    SelectedStaffId: number = null;
    ModalRef: NgbModalRef;

    JobData: any;

    @Input("Mode") Mode: JobOperationActions = JobOperationActions.None;
    _JobOperationActions = JobOperationActions;
    _RequestModel: ComplainRegister = new ComplainRegister();

    @Output() SelectedStaffChanged: EventEmitter<number> = new EventEmitter<number>();

    constructor(public translate: TranslateService, public toastr: ToastrService, public route: ActivatedRoute, public router: Router, public masterService: MasterDataService, protected userService: UserService, public complainService: ComplainService, private modalService: NgbModal) {
        super(translate, toastr, route, router, masterService);
    }

    ngOnInit(): void {

    }

    @Input() set RequestModel(value: ComplainRegister) {
        this._RequestModel = _.cloneDeep(value);
        this.onClear();
    }

    get RequestModel() : ComplainRegister {
        return this._RequestModel;
    }

    SetStaff(): void {
        let req = new StaffAssignmentFilter();
        req.PropertyId = this.PropertyId;
        req.AllPropertyCallCount = true;
        req.IncluedAllstaff = false;

        this.userService.Staff_ForAssignment(req).then(data => {
            this.lstMasterStaffList = data;
            this.StaffList = JSON.parse(JSON.stringify(this.lstMasterStaffList));
            this.onFilter();
        })
    }

    onKeyword(value: string): void {
        this.Keyword = value;
        this.onFilter();
    }

    onClear(): void {
        if (this._RequestModel != null) {
            this._RequestModel.AssignedTo = null;
            this._RequestModel.Remarks = null;
            this._RequestModel.LastActionRemarks = null;
        }
        
        this.SelectedStaffId = null;
        this.PropertyId = null;
        this.clearFilter();
        this.onFilter();
    }

    clearFilter(): void {
        this.Keyword = null;
        this.Filter = 1;
        this.SortBy = 1;
    }

    OpenForAssignment(CallDescriptionId: number, LocationId: number, PropertyId: number, JobData: any): boolean {
        if (this.RequestModel != null) {
            this.ClearErrors();
            this.RequestModel.Operation = this.Mode;
        }

        if (PropertyId == null) {
            let errrorText = this.translate.instant('ERR.ERR_SELECT_PROPERTY');
            alert(errrorText);
            return false;
        }

        if (LocationId == null) {
            let errrorText = this.translate.instant('ERR.ERR_SELECT_LOCATION');
            alert(errrorText);
            return false;
        }

        if (CallDescriptionId == null && !JobData.WorkOrderId) {
            let errrorText = this.translate.instant('ERR.ERR_SELECT_CALL_DESCR');
            alert(errrorText);
            return false;
        }

        if (this.RequestModel != null && this.RequestModel.Operation == JobOperationActions.ReAssign) {
            this.SelectedStaffId = this.RequestModel.AssignedTo;
            this.RequestModel.ClosedReasonCode = 0;
            this.RequestModel.LastActionRemarks = "";
            this.Keyword = null;
            this.SortBy = 1;
            this.Filter = 1;
        }

        let cPropID = this.PropertyId;
        this.PropertyId = PropertyId;

        this.CallDescriptionId = CallDescriptionId;
        this.LocationId = LocationId;

        this.Location = this.masterService.FindLocation(PropertyId, this.LocationId);

        this.CallDescription = this.masterService.FindCallDescription(PropertyId, CallDescriptionId);
        if (this.CallDescription != null)
            this.CallCategory = this.masterService.FindCallCategory(PropertyId, this.CallDescription.CategoryId);

        if (JobData) {
            this.JobData = JobData;
        }
        let ngbModalOptions: NgbModalOptions = {
            backdrop : 'static',
            size: 'lg', 
            centered: true
        };
        this.ModalRef = this.modalService.open(this.content, ngbModalOptions);      

        this.ModalRef.result.then(() => { this.onStaffSelected(this.SelectedStaffId) }, () => { this.onStaffSelected(null); });
            
        
        this.SetStaff();

        //if (this.lstMasterStaffList == null || cPropID != PropertyId) {
        //    this.SetStaff();
        //}

        return true;
    }

    HasSection(row: Staff_Search_Assigment, SectionId: number): boolean {
        if (row.Skills == null)
            return false;

        let arr = row.Sections.filter((val) => {
            return (val == SectionId)
        })

        return (arr.length > 0);
    }

    HasSkill(row: Staff_Search_Assigment, SkillId: number): boolean {
        if (row.Skills == null)
            return false;

        let idx = row.Skills.findIndex((val) => {
            return (val == SkillId)
        })

        return (idx >= 0);
    }

    LocationHasAnySection(Sections: Array<number>, DeptSections: Array<number>): boolean {
        if (Sections == null)
            return false;

        if (DeptSections == null)
            return false;

        if (this.Location.Sections == null)
            return false;

        let arrSec: Array<number> = [];
        let arr1 = this.Location.Sections.filter((val) => {
            let a = (Sections.find(a => a == val));
            if (a && a != -1) {
                arrSec.push(a);
            }
        })

        let arr = DeptSections.filter((val) => {
            let b = arrSec.findIndex(a => a == val);
            if (b >= 0) {
                return true;
            }
        })

        return (arr.length > 0);
    }

    onFilter(): void {
        this.Filter = +this.Filter;
        this.SortBy = +this.SortBy;

        if (this.lstMasterStaffList == null)
            return;

        //this.onKeyword(this.Keyword);

        this.StaffList = this.lstMasterStaffList.filter((row) => {
            let hasSection: boolean = false;
            let hasSkill: boolean = false;
            let hasKeyword: boolean = true;

            if (this.Filter == 2 || this.Filter == 3 || this.Filter == 4) {
                let rowSkill = this.masterService.FindSkill(this.PropertyId, this.CallCategory.SkillId);
                let sections = this.masterService.FindSections(this.PropertyId, rowSkill.DeptId);

                if (rowSkill != null) {
                    hasSection = this.LocationHasAnySection(row.Sections, sections);
                    hasSkill = this.HasSkill(row, this.CallCategory.SkillId);
                }
            }

            if (this.Keyword != null && this.Keyword.length > 0) {
                let data = row.Description.toUpperCase();
                let value = this.Keyword;
                value = value.toLocaleUpperCase();

                hasKeyword = data.indexOf(value) >= 0;
            }

            switch (this.Filter) {
                case 1:
                    return hasKeyword;
                case 2:
                    return (hasSection && hasSkill && hasKeyword);
                case 3:
                    return (hasSection && !hasSkill && hasKeyword);
                case 4:
                    return (!hasSection && hasSkill && hasKeyword);
            }
        });

        switch (this.SortBy) {
            case 1:
                this.StaffList.sort((a, b) => {
                    if (a.Description.toLowerCase() < b.Description.toLowerCase())
                        return -1;

                    if (a.Description.toLowerCase() > b.Description.toLowerCase())
                        return 1;

                    return 0;
                });
                break;
            case 2:
                this.StaffList.sort((a, b) => {
                    if (a.AllOpenCalls < b.AllOpenCalls)
                        return -1;

                    if (a.AllOpenCalls > b.AllOpenCalls)
                        return 1;

                    if (a.Description.toLowerCase() < b.Description.toLowerCase())
                        return -1;

                    if (a.Description.toLowerCase() > b.Description.toLowerCase())
                        return 1;

                    return 0;
                });
                break;
        }
        
    }

    Validate(): void {
        if (this.RequestModel.AssignedTo == null) {
            this.AddError('ERR.ERR_SELECT_STAFF');
        }

        if (this.RequestModel.ClosedReasonCode == null || +this.RequestModel.ClosedReasonCode <= 0) {
            this.AddError('ERR.ERR_SELECT_REASON_FOR_REASSIGNMENT');
        }

        //if (this.RequestModel.AssignedTo == this.SelectedStaffId) {
        //    this.AddError('Staff is assigned same complain');
        //}
    }

    onStaffSelect(staffId: number): void {
        this.SelectedStaffId = staffId;
    }

    onStaffSelected(StaffId: number): void {
        if (this.RequestModel.Operation == JobOperationActions.ReAssign) {
            this.RequestModel.AssignedTo = StaffId;
            this.RequestModel.IsAutoAssign = false;
            return;
        }

        this.clearFilter();
        this.ModalRef.close();
        this.SelectedStaffChanged.emit(StaffId);
    }

    onSubmit(): void {
        this.IsSubmitting = true;

        this.ClearErrors();
        this.Validate();

        if (this.HasErrors) {
            this.IsSubmitting = false;
            return;
        }
        
        this.complainService.Complain_Update(this.RequestModel).then(data => {
            this.FromBaseResponse(data);
            if (this.HasErrors) {
                this.IsSubmitting = false;
                return;
            }
            this.IsSubmitting = false;
            this.GetMultilingualToast('TS.TS_UPDATE_SUCCESS', 'success');
            this.clearFilter();
            this.ModalRef.close();
        }).catch(reason => {
            this.IsSubmitting = false;
        })
    }

    onSort(): void {
        this.onFilter();
    }

}
